import moment from "moment-timezone";

/**
 * Create a template for parsed available time period
 * @param timezone preferred timezone
 */
export default function createParsedAvailableTimePeriod(timezone: TimeZone) {
  // avoid moment DST incorrect
  const date = moment().tz(timezone).startOf("day").add(1, "days");

  // always start at the date's week start date
  const weekStartDateValue = moment(+date)
    .startOf("week")
    .valueOf();

  return {
    start_date: date.toISOString(),
    end_date: null,
    recurring: true,
    intervals: Array(7)
      .fill(weekStartDateValue)
      .reduce((prev, _, i) => {
        // default have no schedule on sat and sun
        if (i === 0 || i === 6) {
          prev[i] = null;
          return prev;
        }

        let nextDate = moment.tz(weekStartDateValue, timezone).add(i, "days");

        while (nextDate < date) {
          nextDate = moment.tz(nextDate.valueOf(), timezone).add(7, "days");
        }

        nextDate.hours(9);

        const start_time = nextDate.toISOString();
        nextDate.hours(17);
        const end_time = nextDate.toISOString();

        prev[i] = [
          {
            start_time,
            end_time,
          },
        ];
        return prev;
      }, [] as ParsedAvailableTimePeriod["intervals"]),
  } as ParsedAvailableTimePeriod;
}
